exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../../../../node_modules/postcss-loader/index.js!../../project/project-list/project-list.component.css"), "");

// module
exports.push([module.id, ".folder-icon {\n    color: #75798C;\n    font-size: 3em;\n    margin-top: 0.8em;\n    margin-bottom: 0.4em;\n}\n\n.owner {\n  float: right;\n  font-size: 0.85em;\n}\n\n.text-title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow:ellipsis;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/folder/folder-list/folder-list.component.css
// module id = 744
// module chunks = 0